import React from 'react';
import trimEnd from 'lodash/trimEnd';
import PropTypes from 'prop-types';

import env from 'Env';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import { LinkTag } from 'Helpers/SEO/Tags';

export default function Canonical({ page, nbPages, path, noResults }) {
  const nextPage = page + 2;
  const prevPage = page;
  const baseUrl = trimEnd(`${env.appProtocol}://${env.appUrl}/${window.locale}/${decodeURIComponent(path)}`);

  let nextUrl = `${baseUrl}?page=${nextPage}`;
  if (page === (nbPages - 1)) {
    nextUrl = '';
  }
  let prevUrl = `${baseUrl}?page=${prevPage}`;
  if (page === 0) {
    prevUrl = '';
  }
  if (page === 1) {
    prevUrl = baseUrl;
  }

  // Hide pages over 10 except in certain places
  // const isPageIndexUnlimited = path.startsWith('all-games') || path.startsWith('all-dlc') || path.startsWith('publishers') || path.startsWith('blog');
  // const prerender404 = (!isPageIndexUnlimited && page > 9) || noResults;

  let pagedUrl = baseUrl;

  // Set blog canonicals to en
  if (pagedUrl.includes('/blog') && window.locale) {
    pagedUrl = pagedUrl.replace(`/${window.locale}/`, '/en/');
  }

  // Add page number to url
  if (page > 0) {
    pagedUrl += `?page=${page + 1}`;
  }

  // Should next / prev be shown
  const showPrevMetaLink = page !== 0;
  const showNextMetaLink = page !== (nbPages - 1);

  return (
    <>
      {showPrevMetaLink && <LinkTag rel="prev" href={prevUrl} />}
      {showNextMetaLink && <LinkTag rel="next" href={nextUrl} />}
      {noResults && <NoIndex />}
    </>
  );
}

Canonical.propTypes = {
  page: PropTypes.number,
  nbPages: PropTypes.number,
  path: PropTypes.string.isRequired,
  noResults: PropTypes.bool,
};

Canonical.defaultProps = {
  page: 1,
  nbPages: 1,
  displayRawUrl: false,
  noResults: false,
};
